<template>
  <div class="small-content-height">
    <div class="confirm">
      <img src="/images/confirm-logo.png" width="80px" height="80px" />

      <div class="small-title" style="margin-top: 10px">
        {{ this.$t("chup_anh_minh_chung") }}
      </div>

      <div class="mt-2">
        {{ $t("ip") }}: <span style="font-weight: bold">{{ ip }}</span>
        {{ $t("email") }}:
        <span style="font-weight: bold">{{ user.email }}</span>
      </div>

      <v-card class="mt-2" style="width: 100%; max-width: 1280px">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6">
                  <v-card outlined class="fill-height ma-0">
                    <v-card-title>Camera</v-card-title>

                    <div
                      v-if="!isCameraAvailable && !isSharingScreen"
                      class="pa-2 text-center"
                    >
                      <v-btn
                        block
                        color="secondary"
                        class="mb-2"
                        @click="shareScreen"
                      >
                        <v-icon left>mdi-monitor-screenshot</v-icon>
                        {{ $t("share_screen") }}
                      </v-btn>

                      <template v-if="!hasTakeImage">
                        <div>
                          {{ $t("khong_thay_cam") }}
                        </div>

                        <div>
                          {{ $t("nhan") }}
                          <img
                            src="data:image/png;base64,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"
                          />
                          {{ $t("de_cho_phep") }}
                        </div>

                        <div>
                          {{ $t("hoac_nhan") }}
                        </div>

                        <div>
                          {{ $t("yeu_cau") }}
                        </div>

                        <div>
                          {{ $t("nhu_mau") }}
                        </div>

                        <img
                          src="@/assets/screenshot-sample.jpg"
                          alt="Screenshot Sample"
                          style="width: 100%; object-fit: contain"
                        />
                      </template>
                    </div>

                    <video
                      ref="cam"
                      playsinline
                      autoplay
                      muted
                      class="px-2"
                      :style="{
                        display:
                          !isCameraAvailable && !isSharingScreen ? 'none' : '',
                      }"
                      style="width: 100%;"
                      @loadedmetadata="camLoaded"
                    />
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card outlined class="fill-height ma-0">
                    <v-card-title>
                      <div>{{ $t("anh_da_chup") }}</div>

                      <v-btn
                        small
                        class="ml-2"
                        color="secondary"
                        :disabled="!isCameraAvailable && !isSharingScreen"
                        @click="takeSnapshot"
                      >
                        <v-icon left>mdi-camera</v-icon>
                        {{ $t("chup_anh") }}
                      </v-btn>
                    </v-card-title>

                    <canvas ref="img" class="px-2" style="width: 100%;" />
                  </v-card>
                </v-col>
              </v-row>

              <v-row justify="end">
                <v-btn
                  :disabled="!hasTakeImage"
                  cols="6"
                  color="primary"
                  @click="confirmInfo"
                >
                  <v-icon left>mdi-book-account</v-icon>
                  {{ $t("xac_nhan_thong_tin") }}
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {},

  data: () => ({
    camWidth: 0,
    camHeight: 0,
    camStream: undefined,
    imgTrack: undefined,
    hasTakeImage: false,

    isSharingScreen: false,
    isCameraAvailable: false,
    snapshotWithCamera: true,
  }),

  computed: {
    ...mapState("user", ["ip", "user"]),
  },

  mounted() {
    let facingMode = "user";
    let constraints = {
      audio: false,
      video: {
        facingMode: facingMode,
      },
    };

    // Get Camera Device
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        if (this.$refs.cam) {
          this.isCameraAvailable = true;

          this.$refs.cam.srcObject = stream;
          this.camStream = stream;
        }
      })
      .catch((error) => {
        console.error("Can not get user media", error);
        this.isCameraAvailable = false;
      });
  },

  methods: {
    camLoaded() {
      if (!this.$refs.cam) return;
      const ratio = this.$refs.cam.videoWidth / this.$refs.cam.videoHeight;
      this.camWidth = this.$refs.cam.videoWidth;
      this.camHeight = parseInt(this.camWidth / ratio, 10);
    },

    takeSnapshot() {
      const canvas = this.$refs.img;

      if (!canvas) return;
      canvas.width = this.camWidth;
      canvas.height = this.camHeight;

      const video = this.$refs.cam;
      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, this.camWidth, this.camHeight);
      this.hasTakeImage = true;

      if (this.imgTrack) {
        this.snapshotWithCamera = false;
        this.imgTrack.stop();
        video.srcObject = this.camStream;
        this.imgTrack = undefined;

        this.isSharingScreen = false;
      }
    },

    shareScreen() {
      navigator.mediaDevices
        .getDisplayMedia({ audio: false })
        .then((mediaStream) => {
          this.isSharingScreen = true;

          const video = this.$refs.cam;
          video.srcObject = mediaStream;
          this.imgTrack = mediaStream.getVideoTracks()[0];
          this.imgTrack.onended = () => {
            video.srcObject = this.camStream;
            this.isSharingScreen = false;
          };
        })
        .catch((err) => {
          console.error("Error Share Screen", err);
          this.isSharingScreen = false;
        });
    },

    async confirmInfo() {
      const img = this.$refs.img;
      this.$store.commit("student/SET_IMAGE", img);
      this.$store.commit(
        "student/SET_SNAPSHOT_WITH_CAM",
        this.snapshotWithCamera
      );
      this.stopCamera();
      await this.$router.push({ name: "StudentInfo" });
    },

    stopCamera() {
      if (!this.camStream) return;

      const tracks = this.camStream.getVideoTracks();

      for (const track of tracks) {
        track.stop();
      }
    },
  },
};
</script>

<style scoped>
.confirm {
  padding: 10px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.cam-video {
  width: 100%;
  height: 300px;
}
</style>
